import { WorkflowTrigger } from '@frontend/workflow/types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum SlotTriggerName {
    SLOT_PACKAGE_CANCELED = 'slot_package_canceled',
    SLOT_PACKAGE_FAILED = 'slot_package_failed',
    SLOT_PACKAGE_PROCESSED = 'slot_package_processed',
    SLOT_PACKAGE_SKIPPED = 'slot_package_skipped',
    SLOT_STATE_CHANGED = 'slot_state_changed',
    SLOT_VERIFIED_EMPTY = 'slot_verified_empty',
    SLOT_VERIFIED_OCCUPIED = 'slot_verified_occupied'
}

export class SlotTrigger extends WorkflowTrigger {
    static readonly SLOT_PACKAGE_CANCELED = new SlotTrigger(
        SlotTriggerName.SLOT_PACKAGE_CANCELED,
        (
            <FormattedMessage
                id='SlotTrigger.package_canceled'
                description='The displayed value for the SlotTrigger package_canceled'
                defaultMessage='Package canceled'
            />
        )
    );
    static readonly SLOT_PACKAGE_FAILED = new SlotTrigger(
        SlotTriggerName.SLOT_PACKAGE_FAILED,
        (
            <FormattedMessage
                id='SlotTrigger.package_failed'
                description='The displayed value for the SlotTrigger package_failed'
                defaultMessage='Package failed'
            />
        )
    );
    static readonly SLOT_PACKAGE_PROCESSED = new SlotTrigger(
        SlotTriggerName.SLOT_PACKAGE_PROCESSED,
        (
            <FormattedMessage
                id='SlotTrigger.package_processed'
                description='The displayed value for the SlotTrigger package_processed'
                defaultMessage='Package processed'
            />
        )
    );
    static readonly SLOT_PACKAGE_SKIPPED = new SlotTrigger(
        SlotTriggerName.SLOT_PACKAGE_SKIPPED,
        (
            <FormattedMessage
                id='SlotTrigger.package_skipped'
                description='The displayed value for the SlotTrigger package_skipped'
                defaultMessage='Package skipped'
            />
        )
    );
    static readonly SLOT_STATE_CHANGED = new SlotTrigger(
        SlotTriggerName.SLOT_STATE_CHANGED,
        (
            <FormattedMessage
                id='SlotTrigger.state_changed'
                description='The displayed value for the SlotTrigger state_changed'
                defaultMessage='State changed'
            />
        )
    );
    static readonly SLOT_VERIFIED_EMPTY = new SlotTrigger(
        SlotTriggerName.SLOT_VERIFIED_EMPTY,
        (
            <FormattedMessage
                id='SlotTrigger.verified_empty'
                description='The displayed value for the SlotTrigger verified_empty'
                defaultMessage='Verified empty'
            />
        )
    );
    static readonly SLOT_VERIFIED_OCCUPIED = new SlotTrigger(
        SlotTriggerName.SLOT_VERIFIED_OCCUPIED,
        (
            <FormattedMessage
                id='SlotTrigger.verified_occupied'
                description='The displayed value for the SlotTrigger verified_occupied'
                defaultMessage='Verified occupied'
            />
        )
    );

    static override readonly ALL = [
        SlotTrigger.SLOT_PACKAGE_CANCELED,
        SlotTrigger.SLOT_PACKAGE_FAILED,
        SlotTrigger.SLOT_PACKAGE_PROCESSED,
        SlotTrigger.SLOT_PACKAGE_SKIPPED,
        SlotTrigger.SLOT_STATE_CHANGED,
        SlotTrigger.SLOT_VERIFIED_EMPTY,
        SlotTrigger.SLOT_VERIFIED_OCCUPIED,
        ...super.ALL
    ];

    static override getByValue(trigger: string): SlotTrigger | WorkflowTrigger | undefined {
        return this.ALL.find((t) => t.value === trigger);
    }
}
